function CurrencyFilter (numeral) {
  function filter (value) {
    if (value == null) return
    let v = value / 100
    return 'R$ ' + numeral(v).format('0,0.00')
  }

  return {
    filter
  }
}

export default CurrencyFilter
